import { render } from "./MissMundo.vue?vue&type=template&id=2ba342f6&scoped=true"
import script from "./MissMundo.vue?vue&type=script&lang=js"
export * from "./MissMundo.vue?vue&type=script&lang=js"

import "./MissMundo.vue?vue&type=style&index=0&id=2ba342f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba342f6"]])

export default __exports__